import { IconName } from '@talos/kyoko';

/** Shared by the market card badges and the Fees / Firm Liquidity toggles that control them. */
export const FEES_ICON = IconName.CurrencyDollar;
export const FIRM_LIQUIDITY_ICON = IconName.Scale;
